import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styled from 'styled-components';
import { breakpoint, clearfix } from '@zocdoc-frontend-common/styles-grid';
import { FontFamily } from '@zocdoc-frontend-common/styles-typography';
import { navy, grey10 } from '@zocdoc/branding/colors';

const Header = styled.div`
    ${clearfix}
    background-color: ${grey10};
    box-sizing: border-box;
    color: ${navy};
    cursor: pointer;
    min-width: 40px;
    padding: 8px 15px 8px 15px;
    letter-spacing: 0.04px;

    ${breakpoint.small} {
        font: 15px/20px ${FontFamily.SharpSansBold};
    }
`;

export default class DropdownHeader extends Component {
    static propTypes = {
        className: PropTypes.string,
    };

    render() {
        const { children, className } = this.props;

        return <Header className={className}>{children}</Header>;
    }
}
